import React from "react";
import { makeStyles, Box, Link } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";
import { languages } from "../i18n/languagesUsed";
import ReactCountryFlag from "react-country-flag";

const useStyles = makeStyles((theme) => ({
  link: {
    position: "relative",
    fontWeight: 500,
    fontSize: "0.875rem",
    letterSpacing: "0.02em",
    fontFamily: '"Inter", "Roboto", system-ui, sans-serif',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 6,
    color: "inherit",
    display: "inline-block",
    transition: "color 0.2s ease, background-color 0.2s ease",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 2,
      left: "50%",
      transform: "translateX(-50%) scaleX(0)",
      width: "60%",
      height: 2,
      backgroundColor: theme.palette.primary.main,
      borderRadius: 2,
      transition: "transform 0.22s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "none",
      backgroundColor: "rgba(233, 58, 36, 0.06)",
      "&::after": {
        transform: "translateX(-50%) scaleX(1)",
      },
    },
  },
  languageSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginLeft: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    borderLeft: "1px solid rgba(0, 0, 0, 0.1)",
  },
  flag: {
    cursor: "pointer",
    display: "block",
    transition: "transform 0.18s ease, opacity 0.18s ease",
    opacity: 0.75,
    "&:hover": {
      transform: "scale(1.25)",
      opacity: 1,
    },
  },
}));

const MenuNavBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const changeLanguage = (lng) => {
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
  };

  const navLinks = [
    { labelKey: "nav_menu.home", hrefKey: "nav_menu.link_home" },
    { labelKey: "nav_menu.reserved_area", hrefKey: "nav_menu.link_reserved_area" },
    { labelKey: "nav_menu.products", hrefKey: "nav_menu.link_products" },
    { labelKey: "nav_menu.gallery", hrefKey: "nav_menu.link_gallery" },
    { labelKey: "nav_menu.support", hrefKey: "nav_menu.link_support" },
    { labelKey: "nav_menu.contact_us", hrefKey: "nav_menu.link_contact_us" },
  ];

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      {navLinks.map(({ labelKey, hrefKey }) => (
        <Link
          key={labelKey}
          href={t(hrefKey)}
          className={classes.link}
          target="_blank"
        >
          {t(labelKey)}
        </Link>
      ))}

      <div className={classes.languageSection}>
        {languages.map((language) => {
          if (i18n.language !== language.key)
            return (
              <ReactCountryFlag
                key={language.key}
                onClick={() => changeLanguage(language.key)}
                countryCode={language.countryCode}
                svg
                className={classes.flag}
                style={{ width: "1.4em", height: "1.4em" }}
                title={language.countryCode}
              />
            );
          return null;
        })}
      </div>
    </Box>
  );
};

export default MenuNavBar;
